import type { RyftRequiredDocument } from "./components/RyftNonHostedOnboardingProvider.shared";

export const MINIMUM_DOCUMENT_FILE_SIZE = 10 * 1024; // 10KB

export const MAXIMUM_DOCUMENT_FILE_SIZE = 4 * 1024 * 1024; // 4MB

export const SUPPORTED_DOCUMENT_FILE_EXTENSIONS = [
  "pdf",
  "jpeg",
  "png",
] as const;

export const ACCEPTED_DOCUMENT_FILES = SUPPORTED_DOCUMENT_FILE_EXTENSIONS.map(
  (extension) => `.${extension}`,
).join(",");

export const DOCUMENT_TYPES_REQUIRING_BACK = [
  "NationalId",
  "DriversLicense",
] as const satisfies ReadonlyArray<RyftRequiredDocument["types"][number]>;

export const DOCUMENT_CATEGORY_LABELS = {
  Authorization: "Authorization",
  ProofOfAddress: "Proof of address",
  ProofOfBusiness: "Proof of business",
  ProofOfIdentity: "Proof of identity",
} satisfies Record<RyftRequiredDocument["category"], string>;

export const DOCUMENT_TYPE_LABELS = {
  ArticlesOfIncorporation: "Articles of incorporation",
  BankStatement: "Bank statement",
  BusinessRegistration: "Business registration",
  CreditCardStatement: "Credit card statement",
  DriversLicense: "Driving licence",
  LetterOfAuthorization: "Letter of authorization",
  NationalId: "National ID",
  OfficialGovernmentLetter: "Official government letter",
  Passport: "Passport",
  PropertyTaxAssessment: "Property tax assessment",
  TaxReturn: "Tax return",
  UtilityBill: "Utility bill",
} satisfies Record<RyftRequiredDocument["types"][number], string>;

export const RYFT_TERMS_URL = "https://ryftpay.com/legal/terms-conditions";
